export const computeActivityStatus = (
  {
    isPublished,
    activityStartAt,
    publishedAt,
    registered,
    capacity,
  },
  now = new Date(),
) => {
  if (!isPublished) {
    return {
      theme: "unpublished",
      text: "未上架",
      registrationEnabled: false,
    };
  }

  const activityStart = activityStartAt ? new Date(activityStartAt) : null;
  const publishAt = publishedAt ? new Date(publishedAt) : null;
  const hasActivityStart =
    activityStart && !Number.isNaN(activityStart.getTime());
  const hasPublishAt = publishAt && !Number.isNaN(publishAt.getTime());
  const registeredN = Number(registered);
  const capacityN = Number(capacity);
  const hasCountAndCapacity =
    Number.isFinite(registeredN) && Number.isFinite(capacityN);

  if (hasActivityStart && now >= activityStart) {
    return {
      theme: "ended",
      text: "活動截止",
      registrationEnabled: false,
    };
  }

  const inRegistrationPeriod =
    hasPublishAt && hasActivityStart && now > publishAt && now < activityStart;

  if (inRegistrationPeriod) {
    if (hasCountAndCapacity && registeredN >= capacityN) {
      return {
        theme: "full",
        text: "已額滿",
        registrationEnabled: false,
      };
    }
    if (hasCountAndCapacity && capacityN - registeredN <= 20) {
      return {
        theme: "almostFull",
        text: "即將額滿",
        registrationEnabled: true,
      };
    }
    return {
      theme: "open",
      text: "報名中",
      registrationEnabled: true,
    };
  }

  if (hasActivityStart && now < activityStart) {
    return {
      theme: "upcoming",
      text: "即將開始",
      registrationEnabled: false,
    };
  }

  return {
    theme: "published",
    text: "已上架",
    registrationEnabled: false,
  };
};
